import styled from '@emotion/styled';
import { PropsWithChildren } from 'react';
import { mqUser } from 'utils/responsive';

const Button = styled.button<
    Partial<Props> & {
        textColor: string;
        borderColor: string;
        mimWidth?: string;
    }
>`
    display: block;
    padding: 15px 25px;
    border: 1px solid ${(props) => `var(--${props.borderColor})`};
    outline: none;
    border-radius: 60px;
    background-color: ${(props) => `var(--${props.bgColor})`};
    font-size: var(--font-x-large);
    font-weight: var(--font-bold);
    color: var(--${(props) => props.textColor});
    white-space: nowrap;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props) => (props.disabled ? 0.2 : 1)};

    ${(props) => props.minWidth && `min-width: ${props.minWidth}`};

    &:not(:disabled):hover {
        opacity: 0.7;
    }

    ${mqUser('SP')} {
        padding: 15px;
        font-size: var(--font-large);
        width: 100% !important;
    }
`;

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    bgColor: string;
    fontColor?: string;
    minWidth?: string;
}

export const ActionButton: React.FC<PropsWithChildren<Props>> = ({
    disabled,
    style,
    fontColor,
    bgColor,
    minWidth,
    children,
    id = null,
    onClick,
}) => {
    const textColor = fontColor || bgColor === 'white' ? 'gray' : 'white';
    const borderColor = bgColor === 'white' ? 'gray' : 'transparent';
    return (
        <Button
            type="button"
            disabled={disabled}
            bgColor={bgColor}
            textColor={textColor}
            borderColor={borderColor}
            minWidth={minWidth}
            style={style}
            onClick={onClick}
            {...(id && { id })}
        >
            {children}
        </Button>
    );
};
